export enum ISTacticsEnum {
  CHANNEL_OVERLAP = 'channel-overlap',
  LANDING_PAGE_OPTIMISATION = 'landing-page-optimisation',
  SEARCH_GAPS = 'search-gaps',
}
